<div class="box">
  <div class="box-header">
    <div class="pull-left">
      <form class="form-inline">
        <div class="form-group">
          <label class="control-label">No. of entries</label>
        </div>
        <div class="form-group">
          <select style="display: inline;" #selectElem class="form-control" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="page.size" (change)="history$.next({ offset: 0 })">
            @for (size of coreService.sizeOptions; track size) {
              <option [value]="size">{{size}}</option>
            }
          </select>
        </div>
      </form>
    </div>

    <div class="pull-right">
      <button class="btn btn-sm btn-info btn-flat pull-left margin" style="margin-top: 0px;" (click)="resetFilters()">Clear
      filters</button>
    </div>
  </div>
  <div class="box-body">

    <form [formGroup]="form">
      <ngx-datatable appTableScrollHorizontal [externalSorting]="true" [cssClasses]="iconsCss" [loadingIndicator]="isLoading" class="material striped"
        [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [rowHeight]="'50'" [footerHeight]="50"
        [externalPaging]="true" [count]="page.totalElements" [offset]="page.pageNumber" (page)='history$.next($event)'
        (sort)="onSort($event)" [limit]="page.size">

        <ngx-datatable-column [sortable]="false" prop="index" name="{{'Sr No' | uppercase}}" [flexGrow]="0.5">
          <ng-template let-column="column" ngx-datatable-header-template>
            <p>{{column.name}}
            </p>
          </ng-template>

          <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
            <strong>{{(page.size * page.pageNumber) + rowIndex + 1}}</strong>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column  [sortable]="true" name="{{'Username' | uppercase}}"
          [flexGrow]="1">

          <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <p (click)="sort()" style="cursor: pointer;">{{column.name}}
              <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
            </p>
            <input type="text" class="form-control input-sm" placeholder="Filter by {{column.name | titlecase}}"
              formControlName="{{column.prop}}">
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="true" name="{{'Plate Number' | uppercase}}" prop="plate_number" [flexGrow]="1">
          <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <p (click)="sort()" style="cursor: pointer;">{{column.name}}
              <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
            </p>
            <input type="text" class="form-control input-sm" placeholder="Filter by {{column.name | titlecase}}"
              formControlName="{{column.prop}}">
          </ng-template>

          <ng-template let-row="row" ngx-datatable-cell-template>
            <p>{{row.vehicle.plate_number_prefix}} {{row.vehicle.plate_number}}</p>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="true" name="{{'In Time' | uppercase}}" prop="in_time" [flexGrow]="1">
          <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <p (click)="sort()" style="cursor: pointer;">{{column.name}}
              <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
            </p>
          </ng-template>

          <ng-template let-value="value" ngx-datatable-cell-template>
            <p>{{value | date:'dd/MM/yyyy h:mm a'}}</p>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="true" name="{{'Out time' | uppercase}}" prop="out_time" [flexGrow]="1">
          <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <p (click)="sort()" style="cursor: pointer;">{{column.name}}
              <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
            </p>
          </ng-template>

          <ng-template let-value="value" ngx-datatable-cell-template>
            <p>{{value | date:'dd/MM/yyyy h:mm a'}}</p>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </form>
  </div>
</div>
